class DateTime {
    constructor(date, time) {
      this.date = time ? new Date(`${date} ${time}`) : new Date(date);
      this.time = time;
      this.currentDateTime = new Date();
    }

    get timestamp(){
        return Date.parse(this.date);
    }

    //test for timestamp working
    get dateFormatted(){
        return new Date(Date.parse(this.date));
    }

    //current timestamp can be used to compare.
    get currentDateTimestamp(){
        return Date.parse(this.currentDateTime);
    }

    //time difference for disabling
    get timeDifference(){
        return Number(Date.parse(this.date) - Date.parse(this.currentDateTime));
    }

    get timeDifferenceInMinutes() {
        return Number(this.timeDifference / 60000)
    }

    get timeDifferenceInHours() {
        return Number(this.timeDifferenceInMinutes / 60);
    }

    //if the first events timeslot is 6 hours past remove it
    get removeEvent() {
        if (this.timeDifferenceInHours < -6) {
            return true;
        }
        else {
            return false;
        }
    }

    get LongDate(){
        const options = { weekday: 'long', month: 'long', day: 'numeric' };
        return this.date.toLocaleDateString(undefined, options)
    }
}

export default DateTime;